// //ボタンクリックで音楽再生
// document.addEventListener('DOMContentLoaded', () => {
 
//   const playLists = document.querySelectorAll('.playlist');
 
//   playLists.forEach((playList) => {
 
//     // 全てのトラックを取得
//     const tracks = playList.querySelectorAll('.tracks');
 
//     // 各トラックで
//     tracks.forEach((track) => {
//       // ボタンと audio 要素をタイトルのテキストの前に追加
//         const playBtnElem =
//         `<audio></audio>`;
//         track.insertAdjacentHTML('afterbegin', playBtnElem);
 
//       // 再生ボタン
//         const playBtn = track.querySelector('button.play');
 
//       // audio 要素
//       const audio = track.querySelector('audio');
//       // src に data-audio-src 属性の値を設定
//       audio.src = track.dataset.audioSrc;
 
//       // 再生終了時
//       audio.addEventListener('ended', () => {
//         // ボタンから playing クラスを削除し、aria-label を変更
//         playBtn.classList.remove('playing');
//         playBtn.setAttribute('aria-label', 'Play');
//       }, false);
 
//       // 再生ボタンをクリックした際の処理
//       playBtn.addEventListener('click', (e) => {
//         // 再生・一時停止を実行する関数を呼び出す
//         toggleBtn(track);
//       }, false);
 
//     });
 
//     // 音声データを再生する非同期関数（Async Function）
//     async function playAudio(track) {
//       const audio = track.querySelector('audio');
//       try {
//         await audio.play();
//         const btn = track.querySelector('button.play');
//         btn.classList.add('playing');
//         // aria-label 属性の値を更新
//         btn.setAttribute('aria-label', 'Pause');
//       } catch (err) {
//         console.warn(err);
//       }
//     }
 
//     // トグルボタンのリスナー
//     function toggleBtn(track) {
//       // 現在選択されているトラックのボタン
//       const btn = track.querySelector('button.play');
//       const audio = track.querySelector('audio');
 
//       if (audio.paused) {
//         // 停止中であれば setupAndPlay() を呼び出して再生
//         playAudio(track);
//       } else {
//         // 再生中であれば停止
//         audio.pause();
//         // 先頭に戻す
//         audio.currentTime = 0;
//         playAudio(track);
//         // ボタンから playing クラスを削除し、aria-label を変更
// //        btn.setAttribute('aria-label', 'Play');
// //        btn.classList.remove('playing');
//       }
//     }
 
//     // 現在クリックされた音声データのみを再生（他に再生中の音声データがあれば停止）
//     playList.addEventListener('play', (e) => {
//       // 全ての audio 要素を取得
//       const audios = playList.querySelectorAll('audio');
//       // それぞれの audio 要素で以下を実行
//       audios.forEach((audio) => {
//         // play イベントが発生した要素が自身でなければ
//         if (audio !== e.target) {
//           // 停止
//           audio.pause();
//           // 先頭に戻す
//           audio.currentTime = 0;
//           // 親要素（li 要素）
//           const parent = audio.parentElement;
//           // ボタンから playing クラスを削除し、aria-label を変更
//           const btn = parent.querySelector('button.play');
//           btn.classList.remove('playing');
//           btn.setAttribute('aria-label', 'Play');
//         }
//       });
//     }, true); // 第3引数（useCapture）を true に
//   });
// });


//ボタンクリックで音楽再生
document.addEventListener('DOMContentLoaded', () => {
  const playLists = document.querySelectorAll('.playlist');

  playLists.forEach((playList) => {
    const tracks = playList.querySelectorAll('.tracks');

    tracks.forEach((track) => {
      // audio タグを挿入
      const audioElem = `<audio></audio>`;
      track.insertAdjacentHTML('afterbegin', audioElem);

      const playBtn = track.querySelector('button.play');
      const audio = track.querySelector('audio');

      // データ属性から音源セット
      audio.src = track.dataset.audioSrc;

      // 再生終了時の処理
      audio.addEventListener('ended', () => {
        playBtn.classList.remove('playing');
        playBtn.setAttribute('aria-label', 'Play');
      });

      // 再生ボタンクリック時のトグル処理
      playBtn.addEventListener('click', () => {
        toggleBtn(track);
      });
    });

    // 再生処理
    async function playAudio(track) {
      const audio = track.querySelector('audio');
      try {
        await audio.play();
        const btn = track.querySelector('button.play');
        btn.classList.add('playing');
        btn.setAttribute('aria-label', 'Pause');
      } catch (err) {
        console.warn(err);
      }
    }

    // トグル処理：再生中なら止めて再スタート、停止中なら再生
    function toggleBtn(track) {
      const btn = track.querySelector('button.play');
      const audio = track.querySelector('audio');

      if (audio.paused) {
        playAudio(track);
      } else {
        audio.pause();
        audio.currentTime = 0;
        playAudio(track);
      }
    }
  });

  // 全体で再生イベントを監視し、他の音声を停止する処理（playlistをまたいでも動作）
  document.addEventListener('play', (e) => {
    const audios = document.querySelectorAll('audio');
    audios.forEach((audio) => {
      if (audio !== e.target) {
        audio.pause();
        audio.currentTime = 0;
        const parent = audio.parentElement;
        const btn = parent.querySelector('button.play');
        if (btn) {
          btn.classList.remove('playing');
          btn.setAttribute('aria-label', 'Play');
        }
      }
    });
  }, true); // useCapture: true でバブリング前に検知
});

